export const DEFAULT_POOL_ID = 'default_pool';
export const DEFAULT_POOL_NAME = 'Default Pool';
export const DEFAULT_POOL_UNKNOWN_JOB_TITLE = 'unknown'; // used with default pool to handle tickets without labor data
export const HOUSE_ACCOUNT_NAME = 'House Account';

export enum TipCalculatorMethod {
  SHARE = 'share',
  NONE = 'none',
}

export enum CalculatorRuleCondition {
  LABOR_CAP = 'labor_cap',
}

export enum CalculatorSplitMethod {
  NONE = 'none',
  EVENLY = 'evenly',
  TIME_WORKED = 'time_worked',
}

export enum CalculatorParticipantType {
  HOUSE = 'house',
  JOB = 'job',
}

export enum LaborCapMethod {
  FIXED_HOURS = 'fixed_hours',
}

export enum LaborCapPerOption {
  GROUP = 'group',
}

export enum RuleFundSource {
  AUTO_GRATUITIES = 'auto_gratuities',
  TIPS = 'tips',
}

export enum ShareEligibilityMethod {
  BY_SEGMENT = 'by_segment',
  BY_TICKET = 'by_ticket',
}

export enum ShareRemainderType {
  NONE = 'none',
  SELF = 'self',
  POOL = 'pool',
}

export enum ShareRuleType {
  TIP = 'tip',
  CATEGORY = 'category',
  CATEGORY_GROUP = 'category_group',
  DEFAULT_POOL = 'default_pool',
}

export interface IRemainderCondition {
  type: CalculatorRuleCondition;
  hours?: number;
  capMethod?: LaborCapMethod;
  per?: LaborCapPerOption;
}

export interface ICalculatorParticipant {
  name: string;
  type: CalculatorParticipantType;
}

export interface IBeneficiary extends ICalculatorParticipant {
  split?: CalculatorSplitMethod;
}

export interface IRemainderBeneficiary {
  participants: ICalculatorParticipant[];
  split?: CalculatorSplitMethod;
  conditions?: IRemainderCondition[];
  sources?: RuleFundSource[];
}

export interface ICalculatorRuleRemainder {
  type: ShareRemainderType;
  beneficiaries?: IRemainderBeneficiary[];
}

export interface ICalculatorRuleSharePolicyShare {
  category?: string;
  eligibilityMethod: ShareEligibilityMethod;
  beneficiaries: IBeneficiary[];
  share: number;
  sources: RuleFundSource[];
  type: ShareRuleType;
}

export interface ICalculatorRuleSharePolicy {
  isSharedTerminal: boolean;
  remainder: ICalculatorRuleRemainder;
  shares: ICalculatorRuleSharePolicyShare[];
}

export interface ICalculatorRule {
  additionalContributors?: ICalculatorParticipant[];
  default?: boolean;
  includeNoLabor?: boolean;
  contributor?: ICalculatorParticipant;
  value: number;
  sharePolicy?: ICalculatorRuleSharePolicy;
}

export interface ICategoryGroup {
  name: string;
  categories: string[];
}

export interface ICalculatorRules {
  id: string;
  siteId: string;
  method: TipCalculatorMethod;
  rules: ICalculatorRule[];
  categoryGroups: ICategoryGroup[];
  participants: ICalculatorParticipant[];
  createdAt?: string;
  updatedAt?: string;
}

export interface ICreateUpdateCalculatorRules {
  method: TipCalculatorMethod;
  rules: ICalculatorRule[];
  categoryGroups: ICategoryGroup[];
  participants?: ICalculatorParticipant[];
}

export const calculatorParticipants: ICalculatorParticipant[] = [
  {
    name: HOUSE_ACCOUNT_NAME,
    type: CalculatorParticipantType.HOUSE,
  },
];
